import { useMutation, useQueryClient } from '@tanstack/react-query'

import { contractsApi } from '../api/contractsApi'
import { contractsQueries } from '../api/contractsQueries'
import type { UpdateContractRequest } from '../types/contracts.types'

type UpdateContractVariables = {
  organisationId: string
  contractId: string
  payload: UpdateContractRequest
}

export const useUpdateContractMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      organisationId,
      contractId,
      payload,
    }: UpdateContractVariables) =>
      contractsApi.updateContract(organisationId, contractId, payload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: contractsQueries.lists() }),
  })
}
